import { forwardRef } from "react";
import { Trash2 } from "lucide-react";
import Button from "../../../../components/Button/Button";

const FormSection = forwardRef(({ icon: Icon, title, subtitle, onDelete, children }, ref) => (
  <div className="card lp-form-section" ref={ref}>
    <div className="card-header d-flex align-items-center gap-3">
      {Icon && (
        <span className="lp-form-section__icon">
          <Icon size={16} />
        </span>
      )}
      <div className="flex-grow-1">
        <div className="main-title-page">{title}</div>
        {subtitle && <small className="text-muted">{subtitle}</small>}
      </div>
      {onDelete && (
        <Button
          variant="link"
          size="sm"
          className="lp-btn-icon-only lp-btn-danger-icon"
          icon={<Trash2 size={16} />}
          onClick={onDelete}
          aria-label={`Remove ${title}`}
          title="Remove section"
        />
      )}
    </div>
    <div className="card-body">{children}</div>
  </div>
));

export default FormSection;
